/* eslint-disable */
/* tslint:disable */
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

import {
  AddDivisionsToAgeGroupRequest,
  AddDivisionsToPageantRequest,
  EventDivisionModel,
  RemoveDivisionFromAgeGroupRequest,
  RemoveDivisionFromPageantRequest,
} from './data-contracts';
import { ContentType, HttpClient, RequestParams } from './http-client';

export class EventDivisions<SecurityDataType = unknown> extends HttpClient<SecurityDataType> {
  /**
   * No description
   *
   * @tags EventDivisions
   * @name GetAllList
   * @request GET:/EventDivisions/GetAll
   */
  getAllList = (params: RequestParams = {}) =>
    this.request<EventDivisionModel[], any>({
      path: `/EventDivisions/GetAll`,
      method: 'GET',
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @tags EventDivisions
   * @name ByPageantDetail
   * @request GET:/EventDivisions/byPageant/{pageantId}
   */
  byPageantDetail = (pageantId: number, params: RequestParams = {}) =>
    this.request<EventDivisionModel[], any>({
      path: `/EventDivisions/byPageant/${pageantId}`,
      method: 'GET',
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @tags EventDivisions
   * @name EventDivisionsDetail
   * @request GET:/EventDivisions/{id}
   */
  eventDivisionsDetail = (id: number, params: RequestParams = {}) =>
    this.request<EventDivisionModel, any>({
      path: `/EventDivisions/${id}`,
      method: 'GET',
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @tags EventDivisions
   * @name EventDivisionsUpdate
   * @request PUT:/EventDivisions/{id}
   */
  eventDivisionsUpdate = (id: number, data: EventDivisionModel, params: RequestParams = {}) =>
    this.request<EventDivisionModel, any>({
      path: `/EventDivisions/${id}`,
      method: 'PUT',
      body: data,
      type: ContentType.Json,
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @tags EventDivisions
   * @name EventDivisionsDelete
   * @request DELETE:/EventDivisions/{id}
   */
  eventDivisionsDelete = (id: number, params: RequestParams = {}) =>
    this.request<void, any>({
      path: `/EventDivisions/${id}`,
      method: 'DELETE',
      ...params,
    });
  /**
   * No description
   *
   * @tags EventDivisions
   * @name EventDivisionsCreate
   * @request POST:/EventDivisions
   */
  eventDivisionsCreate = (data: EventDivisionModel, params: RequestParams = {}) =>
    this.request<EventDivisionModel, any>({
      path: `/EventDivisions`,
      method: 'POST',
      body: data,
      type: ContentType.Json,
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @tags EventDivisions
   * @name FindExistingOrCreateNewCreate
   * @request POST:/EventDivisions/FindExistingOrCreateNew
   */
  findExistingOrCreateNewCreate = (data: EventDivisionModel, params: RequestParams = {}) =>
    this.request<EventDivisionModel, any>({
      path: `/EventDivisions/FindExistingOrCreateNew`,
      method: 'POST',
      body: data,
      type: ContentType.Json,
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @tags EventDivisions
   * @name AddDivisionsToPageantCreate
   * @request POST:/EventDivisions/add-divisions-to-pageant
   */
  addDivisionsToPageantCreate = (data: AddDivisionsToPageantRequest, params: RequestParams = {}) =>
    this.request<void, any>({
      path: `/EventDivisions/add-divisions-to-pageant`,
      method: 'POST',
      body: data,
      type: ContentType.Json,
      ...params,
    });
  /**
   * No description
   *
   * @tags EventDivisions
   * @name RemoveDivisionFromPageantCreate
   * @request POST:/EventDivisions/remove-division-from-pageant
   */
  removeDivisionFromPageantCreate = (data: RemoveDivisionFromPageantRequest, params: RequestParams = {}) =>
    this.request<void, any>({
      path: `/EventDivisions/remove-division-from-pageant`,
      method: 'POST',
      body: data,
      type: ContentType.Json,
      ...params,
    });
  /**
   * No description
   *
   * @tags EventDivisions
   * @name AddDivisionsToAgeGroupCreate
   * @request POST:/EventDivisions/add-divisions-to-age-group
   */
  addDivisionsToAgeGroupCreate = (data: AddDivisionsToAgeGroupRequest, params: RequestParams = {}) =>
    this.request<void, any>({
      path: `/EventDivisions/add-divisions-to-age-group`,
      method: 'POST',
      body: data,
      type: ContentType.Json,
      ...params,
    });
  /**
   * No description
   *
   * @tags EventDivisions
   * @name RemoveDivisionFromAgegroupCreate
   * @request POST:/EventDivisions/remove-division-from-agegroup
   */
  removeDivisionFromAgegroupCreate = (data: RemoveDivisionFromAgeGroupRequest, params: RequestParams = {}) =>
    this.request<void, any>({
      path: `/EventDivisions/remove-division-from-agegroup`,
      method: 'POST',
      body: data,
      type: ContentType.Json,
      ...params,
    });
  /**
   * No description
   *
   * @tags EventDivisions
   * @name UpdateDivisionsForPageantCreate
   * @request POST:/EventDivisions/updateDivisionsForPageant
   */
  updateDivisionsForPageantCreate = (
    data: Record<string, number[]>,
    query?: {
      /** @format int32 */
      pageantId?: number;
    },
    params: RequestParams = {}
  ) =>
    this.request<void, any>({
      path: `/EventDivisions/updateDivisionsForPageant`,
      method: 'POST',
      query: query,
      body: data,
      type: ContentType.Json,
      ...params,
    });
}
